import React, {
    useEffect,
    useState
} from 'react';

import { Loader, LoadingView } from '../../components/common/loader';
import { ErrorMessages } from '../../components/error/errorMessages';

import { useAuthSelector } from '../../services/selectors/authSelector';
import { authToken } from '../../storage/authToken';

import { ErrorMessage, SuccessMessage } from '../../components/common/AllConfirmationMessages';

import * as Common from '../../components/common';
import * as Hooks from '../../hooks'

import Axios from '../../networking/interceptor';

const PharmacyAssistants = () => {

    const token = authToken();

    const { pharmacyId, isSupervisor } = useAuthSelector()

    const [showToast, setShowToast] = useState({ successToast: false, errorToast: false })
    const [data, setData] = useState({ loading: false, data: [], error: null })
    const [pharmacistOfTheResponse, setPharmacistOfTheResponse] = useState({ loading: false, data: null, error: null });
    const [selectedAssitants, setSelectedAssitants] = useState([]);

    const getPharmacistList = async () => {
        try {
            setData({ loading: true, data: [], error: null })
            const res = await Axios.get(`driver/get-assistant-driver?pharmacy_id=${pharmacyId}`)

            setData({ loading: false, data: res?.data?.data, error: null })

        } catch (error) {

            setData({ loading: false, data: [], error: error })
        }
    }

    useEffect(() => {
        if (token && isSupervisor === 1 && pharmacyId) {
            getPharmacistList()
        }
        return () => { }
    }, [])


    const handleUpdateAssitantStatus = async (uploadData) => {
        try {
            setPharmacistOfTheResponse({ loading: true, data: null, error: null });
            const res = await Axios.post('driver/update-assistant-status', uploadData);
            setPharmacistOfTheResponse({ loading: false, data: res.data, error: null });
            setShowToast({ successToast: true })

            setTimeout(() => {
                setShowToast({ successToast: false })
            }, 2000);
        } catch (error) {
            setPharmacistOfTheResponse({ loading: false, data: null, error: error });

            setShowToast({ errorToast: true })

            setTimeout(() => {
                setShowToast({ errorToast: false })
            }, 2000);

        }
    }


    const handleContinueProcessing = () => {
        const uploadData = {
            pharmacy_id: pharmacyId,
            drivers: selectedAssitants
        }
        if (pharmacyId && selectedAssitants?.length > 0) {
            handleUpdateAssitantStatus(uploadData)
        }
    }

    useEffect(() => {
        if (data?.data.length > 0) {
            const initialSelections = data?.data?.map((value) => ({
                driver_id: value.driver_id,
                assistant_status: value.assistant_status,
            }));
            setSelectedAssitants(initialSelections);
        }
    }, [data]);

    const handlePharmacySelect = (value) => {
        const updatedSelections = selectedAssitants.map((item) =>
            item.driver_id === value.driver_id
                ? { ...item, assistant_status: item.assistant_status === 0 ? 1 : 0 }
                : item
        );
        setSelectedAssitants(updatedSelections);
    };

    
    return (
        <>
            <div className="app-wrapper flex justify-center ">
                <div className="app-screen no-shades w-full xl:w-3/12 lg:w-4/12 md:w-5/12 sm:w-6/12 h-full overflow-x-hidden ">

                    <div className="relative p-4" >
                        <Common.TopBar />

                        <h1 className='flex items-center justify-center text-lg font-bold mt-2'>Assistants</h1>
                        {data?.loading ?
                            <div className='flex items-center justify-center pb-4 mb-4'>
                                <LoadingView />
                            </div>
                            :
                            data?.error !== null ?
                                <div className='flex items-center justify-center pb-4 mb-4'>
                                    <ErrorMessages error={'Oops! Got an issue whille fetching Pharmacies Detatils.Please try to reload the page again.'} />
                                </div>
                                :
                                data?.data?.length  === 0 ?
                                    <div className="flex items-center justify-center pb-4 mt-4">
                                        <div className="flex items-center justify-center pb-4 mb-4">
                                            <p className='text-gray-800'>Currently, there are no assistants available.</p>
                                        </div>
                                    </div>
                                    :
                                    <React.Fragment>
                                        <div className='bg-gray-100 mt-4 p-4 rounded-md'>
                                            {data?.data?.map((value, index) => (
                                                <div key={index} className=''>
                                                    <label htmlFor={`item-checkbox-${index}`}
                                                        className="cursor-pointer drop-shadow-md item-box flex items-center gap-4 p-4 bg-white rounded-2xl mb-4">
                                                        <div className="avatar flex-shrink-0">
                                                            <div
                                                                className="w-14 h-14 flex items-center justify-center rounded-full object-cover object-top">
                                                                <img className="w-full rounded-lg object-cover object-top" alt=''
                                                                    src={value?.image} style={{ width: '56px', height: '56px' }} />
                                                            </div>
                                                        </div>
                                                        <div className="item-details flex-grow">
                                                            <h1 className="text-lg font-bold text-gray-700">{value?.name?.charAt(0).toUpperCase() + value?.name?.slice(1)} {value?.last_name}</h1>
                                                            <h1 className="text-sm text-gray-400 break-all">{value?.email}</h1>
                                                        </div>
                                                        <div className="item-actions relative flex justify-end items-end flex-shrink-0 flex items-center gap-3">

                                                            <input
                                                                id={`item-checkbox-${index}`}
                                                                type="checkbox"
                                                                name="pharmacy-selection"
                                                                className="peer"
                                                                checked={
                                                                    selectedAssitants?.find(
                                                                        (item) => item?.driver_id === value.driver_id
                                                                    )?.assistant_status === 1
                                                                }
                                                                onChange={() => handlePharmacySelect(value)}
                                                            />
                                                        </div>
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="relative mb-4 mt-6">
                                            <button type="button" onClick={handleContinueProcessing}
                                                className={`text-white ${selectedAssitants?.length > 0 ? 'bg-blue-700 hover:bg-blue-800' : 'bg-blue-100'}
                                                w-full flex items-center justify-center focus:ring-4 focus:ring-blue-300 font-bold rounded-lg text-lg px-5 py-3 me-2 mb-2 
												group-invalid:pointer-events-none group-invalid:opacity-30`}>
                                                {pharmacistOfTheResponse?.loading ? <Loader /> : 'Continue'}
                                            </button>
                                        </div>
                                    </React.Fragment>
                        }
                    </div>
                </div>
            </div>

            {showToast.successToast &&
                <SuccessMessage message={'Updated Sucessfully'} setShowToast={() => setShowToast(prevState => ({ ...prevState, successToast: false }))} />}

            {showToast.errorToast &&
                <ErrorMessage message={'Oops Got an issue while updating please try again.'} setShowToast={() => setShowToast(prevState => ({ ...prevState, errorToast: false }))} />
            }


        </>)
}

export default PharmacyAssistants
